import IconHOC from '../IconHOC';

import { ReactComponent as CheckLargeIcon } from './checkLarge.svg';

export const CheckLarge = IconHOC(CheckLargeIcon);
